import React from 'react';
import { Row, Col, Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

import SchoolPanel from './SchoolPanel';
import AuthorizeRoute from '../api-authorization/AuthorizeRoute';

const Admin = () => (
  <Row>
    <Col style={{ maxWidth: "300px" }} xs={2}>
      <Nav vertical>
        <NavItem>
          <NavLink tag={Link} to="/admin/schools">Schools</NavLink>
        </NavItem>
      </Nav>
    </Col>
    <Col>
      <AuthorizeRoute path='/admin/schools' component={SchoolPanel} />
    </Col>
  </Row>
);

export default Admin;